export const ROBINHOOD_MAINNET_WETH =
  '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73'

export const ROBINHOOD_MAINNET_USDG =
  '0x5fc5360D0400a0Fd4f2af552ADD042D716F1d168'

export const ROBINHOOD_MAINNET_AGGREGATOR =
  '0x8F095848b0eea39FcA166223dc043eBe40895D0c'

export const ROBINHOOD_MAINNET_V3_ADAPTER =
  '0x1108c7387d54394a2Ba34C1f678715Be410E8DEA'

export const ROBINHOOD_MAINNET_V3_QUOTER =
  '0x33e885eD0Ec9bF04EcfB19341582aADCb4c8A9E7'

export const ROBINHOOD_MAINNET_V3_ROUTER =
  '0xCaf681a66D020601342297493863E78C959E5cb2'

export const ROBINHOOD_PROTOCOL_FEE_BPS = 10
export const BPS_DENOMINATOR = 10000

export const ROBINHOOD_V3_FEE_TIERS = [
  100,
  500,
  3000,
  10000,
] as const
